import React from 'react';
import { Box } from '@mui/material';
import { CardWrapper } from '../../requestQuote/components/BaseHeader';
import CoverageCheckbox from './CoverageCheckbox';

interface CoverageLegendProps {
  readonly children: React.ReactNode;
  /** Replaces the card's right padding, e.g. to clear a rail that floats over it. */
  readonly contentPaddingRight?: string;
}

const CoverageLegend = ({
  children,
  contentPaddingRight,
}: CoverageLegendProps) => {
  return (
    <CardWrapper
      style={{
        margin: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }}
      cardStyles={{ paddingRight: contentPaddingRight }}
      boxProps={{ px: 1.5, py: 0 }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CoverageCheckbox.Mandatory />
          <CoverageCheckbox.Selected disabled />
          <CoverageCheckbox.Available disabled />
          <CoverageCheckbox.NotAvailable />
        </div>
        {children}
      </Box>
    </CardWrapper>
  );
};

export default CoverageLegend;
